var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.connected===null)?_c('overwatchLoader',{attrs:{"id":"loader"}}):_vm._e(),_vm._v(" "),_c('network'),_vm._v(" "),_c('error',{attrs:{"error":_vm.error}}),_vm._v(" "),((_vm.connected === true && _vm.user) || (_vm.connected === false))?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7056d97e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = dNLV
// module chunks = 0